import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const VolumeOffSolidIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M2.47 1.47a.75.75 0 0 1 1.06 0l12 12a.75.75 0 1 1-1.06 1.06l-12-12a.75.75 0 0 1 0-1.06Z"/>
        <path d="M4.44 3.5 3.026 4.51H.818c-.49 0-.818.35-.818.877v5.264c0 .526.327.877.818.877h2.21l4.663 3.334c.573.351 1.309 0 1.309-.702v-6.1L4.44 3.5ZM10.9 9.96a3.5 3.5 0 0 1-.425.515.75.75 0 0 0 1.06 1.06c.158-.157.304-.324.439-.5L10.9 9.96ZM12.718 9.657l-1.242-1.242a3.5 3.5 0 0 0-1.001-2.89.75.75 0 1 1 1.06-1.06 5 5 0 0 1 1.183 5.192ZM13.042 12.102c-.14.172-.289.337-.446.494a.75.75 0 1 0 1.06 1.06 8 8 0 0 0 .451-.488l-1.065-1.066Z"/>
        <path d="m14.976 11.916-1.112-1.112A6.522 6.522 0 0 0 14.5 8a6.5 6.5 0 0 0-1.904-4.596.75.75 0 1 1 1.06-1.06 8 8 0 0 1 1.32 9.572ZM9 5.94 5.676 2.615l2.015-1.44C8.264.737 9 1.176 9 1.878v4.061Z"/>
    </svg>
);
VolumeOffSolidIcon.displayName = 'VolumeOffSolidIcon';
export default VolumeOffSolidIcon;
